import { Container } from "react-bootstrap";
import labBanner from "../../assets/img/inner-banner/Lab-Grown-Reports.webp";
import labBannerMobile from "../../assets/img/mobile-banner/Lab-Grown-Reports.webp";

import fancydiamond from "../../assets/img/Icons-Certificate/Fancy-Diamond.jpg";
import fulldiamond from "../../assets/img/Icons-Certificate/Full-Diamond.jpg";
import identification from "../../assets/img/Icons-Certificate/Jewelry-Identification.jpg";

import "./Certificatedetail.css";
import { Link } from "react-router-dom";
import {
  MdKeyboardDoubleArrowRight,
  MdOutlineKeyboardDoubleArrowRight,
} from "react-icons/md";
import { IoCheckmarkDone } from "react-icons/io5";
import { Helmet } from "react-helmet";

export default function LabGrownReports() {
  return (
    <>
      <Helmet>
        {/* Meta tags */}
        <title>Lab Grown Diamond Report | Sreehari Diamond Laboratory </title>
        <meta
          name="description"
          content="Get a trusted report for lab grown diamonds, detailing quality, origin, and grading. Ensure transparency with certified lab-created diamond evaluations"
        />
        <meta
          name="keywords"
          content="lab grown diamond certification, best diamond certification in india, Gemstone Identification Lab, Diamond, Gemological Laboratory, Diamond Testing Lab, Diamond Sealing service, Diamond Hologram Stickers, Hologram Stickers for Certificates, Best diamond online services, 4 cs' of diamonds, 4cs education of diamond"
        />
        {/* OG tags */}
        <meta
          property="og:title"
          content="Lab Grown Diamond Report | Sreehari Diamond Laboratory"
        />
        <meta
          property="og:description"
          content="Get a trusted report for lab grown diamonds, detailing quality, origin, and grading. Ensure transparency with certified lab-created diamond evaluations"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://sreeharidiamondlab.com/lab-grown-reports"
        />
        <meta
          property="og:image"
          content="https://sreeharidiamondlab.com/static/media/Lab-Grown-Reports.f5b76c20f7e22409c3d9.webp"
        />
        <meta property="og:site_name" content="sreehari diamond laboratory" />
        {/* Twitter tags */}
        <meta
          name="twitter:title"
          content="Lab Grown Diamond Report | Sreehari Diamond Laboratory"
        />
        <meta
          name="twitter:description"
          content="Get a trusted report for lab grown diamonds, detailing quality, origin, and grading. Ensure transparency with certified lab-created diamond evaluations"
        />
        <meta
          name="twitter:image"
          content="https://sreeharidiamondlab.com/static/media/Lab-Grown-Reports.f5b76c20f7e22409c3d9.webp"
        />
        <meta name="twitter:site" content="sreehari diamond laboratory" />
        <link
          rel="canonical"
          href="https://sreeharidiamondlab.com/lab-grown-reports"
        />{" "}
      </Helmet>
      <section>
        <Container fluid className="bannersection position-relative p-0">
          <img
            src={window.innerWidth > 568 ? labBanner : labBannerMobile}
            alt="Service banner"
            className="w-100  h-100 object-fit-cover about-banner-img"
          />
          <div className="textoverlay pt-5 d-flex flex-column justify-content-center align-items-center position-absolute top-0 w-100 h-100 text-center"></div>
        </Container>
      </section>
      <section className="hologram-section section-spacing-x section-spacing-y pb-0">
        <div className="container-fluid">
          <div className="row">
            <h1 className="heading mb-3 text-center">Lab Grown Reports </h1>
          </div>
          <p className="mb-1">
            This report gives shape and cut, weight, and measurement, along with
            color description.{" "}
          </p>
          <p>
            The lab-grown Diamonds are accompanied by a specific Chemical Vapour
            Deposition (CVD) diamond, offering detailed insights into its
            origin, characteristics, and quality. As lab-grown diamonds have
            gained immense popularity for their elegance, sustainability, and
            affordability, our report ensures a confident and informed purchase.
          </p>
          <p>
            <b>Each report includes:</b>
          </p>
          <p>
            <IoCheckmarkDone /> Carat weight and precise dimensions of the
            diamond, whether it is a single one.
          </p>
          <p>
            <IoCheckmarkDone /> Clear classification of the diamond's clarity,
            cut, color, origin, and carat weight.
          </p>
          <p>
            <IoCheckmarkDone /> Certification stating whether the diamond is
            perfectly lab-grown or if any structural flaws or inclusions are
            present. Issued exclusively to ensure transparency and authenticity
            for the customer.
          </p>
          <p>
            <IoCheckmarkDone /> This report is presented in a sleek,
            water-resistant, and portable format, which spiflicated lab
            lab-grown diamond along with its certificate. Its transparent design
            allows for immediate visual inspection of both the lab-grown diamond
            and its certificate, while maintaining the security and traceability
            of the contents.
          </p>
          <div className="contact-us-button mt-lg-4 mb-lg-3 mb-4">
            <Link to="/contact-us">
              Contact Us <MdOutlineKeyboardDoubleArrowRight />
            </Link>
          </div>
        </div>
      </section>

      <section className="section-spacing-x">
        <div className="container-fluid">
          <div className="row mb-5">
            <h2 className="text-center mb-4 heading">Other Certificates</h2>
            <div className="col-lg-4 mb-lg-0 mb-3">
              <div className="service-card text-center border rounded">
                <div className="service-image mx-auto">
                  <img src={fulldiamond} alt="service" className="img-fluid" />
                </div>
                <h3 className="mb-0">Full Diamond Grading Reports</h3>
                <p className="mb-3">
                  Our diamond grading reports deliver precise analysis of cut,
                  color, clarity, and carat, providing trustworthy certification
                  that reflects the true quality and value of your diamonds.{" "}
                </p>
                <div className="service-read-more mt-lg-0 mt-2">
                  <Link to="/full-diamond-grading-reports">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 mb-lg-0 mb-3">
              <div className="service-card text-center border rounded">
                <div className="service-image mx-auto">
                  <img
                    src={identification}
                    alt="Jewelry Identification Report | Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <h3 className="mb-0">Diamond Jewelry Reports</h3>
                <p className="mb-3">
                  We offer detailed jewelry identification reports that
                  accurately describe the materials, diamonds, gemstones, and
                  craftsmanship, helping you authenticate and appraise your
                  valuable jewelry pieces.{" "}
                </p>
                <div className="service-read-more mt-lg-0 mt-2">
                  <Link to="/diamond-jewelry-reports">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="service-card text-center border rounded">
                <div className="service-image mx-auto">
                  <img
                    src={fancydiamond}
                    alt="Fancy Diamond Report | Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <h3 className="mb-0">Fancy Diamond Reports</h3>
                <p className="mb-3">
                  Our Diamond reports specialize in grading unique colored
                  diamonds, detailing hue, tone, saturation, and quality to
                  certify the beauty and rarity of your fancy gemstones.{" "}
                </p>
                <div className="service-read-more mt-lg-0 mt-2">
                  <Link to="/fancy-diamond-reports">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
